import React, { useEffect, useState, useRef, PropsWithChildren } from 'react';

import './collapse.less';

type Props = {
  isCollapsed: boolean;
  controlId: string;
};

export default function Collapse({
  isCollapsed,
  children,
  controlId,
}: PropsWithChildren<Props>) {
  const [height, setHeight] = useState<number>();
  const container = useRef<HTMLDivElement>();

  useEffect(() => {
    setHeight(container.current.offsetHeight);
  }, []);

  // Clip only while collapsed so focus rings on edge-aligned inputs aren't cut off when expanded.
  const collapsedStyleProps: React.CSSProperties = {
    maxHeight: 0,
    overflow: 'hidden',
  };

  return (
    <div className="collapseContainer" ref={container}>
      {height ? (
        <div
          className="collapseSection"
          style={isCollapsed ? collapsedStyleProps : {}}
          id={controlId}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
